export default {
  getTreeStatistic: state => state.treeStatistic,
  getForests: state => state.forests.data,

  getAnimalTable: state => state.animalTable,
  getAnimalStatistic: state => state.animalStatistic,
  getAnimalsTypes: state => state.animalsTypes,
  getAnimals: state => state.animals


};
